var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tooltip2",staticClass:"tooltip2"},[_c('div',[_c('a',{staticClass:"fa fa-times tooltip2__close2",on:{"click":_vm.hide}})]),_vm._v(" "),_c('div',{staticClass:"tooltip2__content2"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f36cec38","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Tooltip2.vue
// module id = 1532
// module chunks = 65